<template>
	<div id="app">
		<router-view :key="$route.path" />
		<notifications group="main" position="bottom right" />
		<modals-container />
		<v-dialog />
		<TekaChat :isVisible="!['/', '/ResultAna'].includes($route.path)" />
	</div>
</template>

<script>
import TekaChat from "@/components/src/TekaChatComponent";
export default {
	name: "App",
	components: { TekaChat },
};
</script>

<style lang="less">
@import (reference) url("./assets/variables.less");

#app {
	--primary-color: lightgoldenrodyellow;
	--secondary-color: black;
	--accent-color: blue;
	--text-color: white;
	--menu-width: 100px;
	--default-header-space: 57px;
}

@primary-color: var(--primary-color);
@secondary-color: var(--secondary-color);
@accent-color: var(--accent-color);
@text-color: var(--text-color);

#app {
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
		Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
	height: 100vh;
	width: 100vw;

	/* width */
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px lightgray;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		// .sombra;
		background: dimgray;
		border-radius: 2px;
	}
}

.button-div {
	display: flex;
	justify-content: start;
	margin: 16px 0 0;
	gap: 1rem;
}

.button {
	font-weight: 500;
	padding: 12px 16px;
	font-size: 1.1rem;
	box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	border: 0;
	color: white;
	.clicavel;
	.default-hover;

	&.outline {
		color: #dc143d !important;
		background-color: white;
		border: #dc143d 1px solid;

		align-items: end;
	}

	&:disabled {
		background-color: #b0b0b0 !important;
		color: #ffffffb3 !important;
		cursor: not-allowed !important;
		box-shadow: none !important;
		opacity: 0.6;
	}
}

html,
body {
	display: block;
	height: 100%;
	width: 100%;
	margin: 0;
	padding: 0;
}

.grided-template {
	height: 100vh;
	width: 100vw;
	display: grid;
	grid-template-columns: var(--menu-width, 100px) minmax(0, 1fr);
	transition: grid-template-columns 0.22s ease;

	>div {
		overflow-x: hidden;
		overflow-y: auto;
	}

	.fieldSelected {
		font-size: 0.7rem;
		border: solid 1px white;
		background: #fff;
		display: inline-block;
		// width: calc(100% - 110px);
		margin-left: 10px;
		vertical-align: middle;

		.vs__clear {
			display: none;
		}

		.vs__selected-options {
			display: block;
			// max-width: 93%;
			height: 23px;
		}

		s.vs__selected {
			color: rgba(0, 0, 0, 1) !important;
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		input {
			// display: none;
		}

		svg {
			fill: rgba(0, 0, 0, 1);
		}
	}
}

.v--modal-box.v--modal {
	/*width: 40vw!important;*/
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-radius: 14px;
	border: 1px solid rgba(33, 33, 70, 0.14);
	background: linear-gradient(180deg, #fbfcff 0%, #f5f8ff 100%);
	box-shadow: 0 24px 50px rgba(11, 18, 38, 0.32);
	overflow: hidden;

	> * {
		position: relative;
		z-index: 1;
	}
}

.v--modal-overlay {
	background: rgba(8, 12, 26, 0.52) !important;
	backdrop-filter: blur(2px);

	.v--modal-background-click {
		background: transparent !important;
	}
}

.v--modal {
	.button-container,
	.buttonDiv,
	.dialog-button-container,
	.action-toolbar,
	.button-container.action-toolbar {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: wrap;
		gap: 10px;
		padding-top: 10px;
	}

	.button-container.action-toolbar {
		justify-content: space-between;
		border-top: 1px solid rgba(33, 33, 70, 0.1);
		margin-top: 12px;
		padding-top: 12px;
	}

	.button,
	.confirmation-dialog-button,
	.modal-button {
		border-radius: 8px;
		min-height: 36px;
		padding: 8px 14px;
		font-size: 0.86rem;
		font-weight: 600;
		letter-spacing: 0.01em;
		border: 1px solid rgba(220, 20, 61, 0.22);
		box-shadow: 0 2px 8px rgba(19, 24, 41, 0.14);
		transition: transform 0.15s ease, filter 0.15s ease, box-shadow 0.15s ease;

		&:hover {
			transform: translateY(-1px);
			filter: brightness(1.03);
			box-shadow: 0 5px 12px rgba(19, 24, 41, 0.2);
		}
	}

	.button.ghost,
	.confirmation-dialog-button.ghost,
	.modal-button.ghost,
	.button.outline,
	.modal-button.outline {
		background: #ffffff;
		color: #2a3768 !important;
		border: 1px solid rgba(42, 55, 104, 0.24);
		box-shadow: 0 2px 8px rgba(19, 24, 41, 0.12);

		&:hover {
			background: #eef3ff;
			box-shadow: 0 4px 12px rgba(19, 24, 41, 0.16);
		}
	}

	.title,
	h3.title,
	h4.title,
	h5.title {
		color: #202a4d;
		font-weight: 700;
		letter-spacing: 0.01em;
		margin: 0 0 8px;
	}

	.subtitle {
		color: #57658f;
		font-size: 0.9rem;
		margin: 0 0 10px;
	}
}

.ag-root-wrapper{
	border-radius: 8px;
}

.v-select.vs--single.vs--searchable {
	.vs__spinner {
		width: 3.6em;
		height: 3.6em;
	}

	&.loadingData {
		.vs__spinner {
			display: block !important;
			opacity: 1;
		}

		.vs__open-indicator {
			display: none;
		}
	}
}

.confirmation-dialog-box {
	margin-bottom: 30px;

	width: auto;
	margin: auto;
	padding: 14px;
	border-radius: 10px;
	background: #ffffff;
	border: 1px solid #d7dee8;
	box-shadow: 0 8px 20px rgba(19, 24, 41, 0.14);

	.title {
		text-align: center;
		margin-left: 0;
		margin-top: 4px;
		font-weight: 600;
		font-size: 0.98rem;
		line-height: 1.35;
		color: #2b355f;
		margin-block-end: 0;
	}

	.dialog-button-container {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		gap: 10px;

		.confirmation-dialog-button {
			.button;
			min-width: 120px;
		}
	}
}

//   .options-bunch-cell-editor{

//     background: red;
// }

.vs__dropdown-toggle {
	overflow: hidden;
	/* Garante que nada dentro do contêiner ultrapasse */
	white-space: nowrap;
	/* Mantém o texto em uma linha */
	text-overflow: ellipsis;
	/* Exibe "..." no final do texto que ultrapassa o tamanho */
	max-height: 35px;
	/* Define o tamanho máximo de altura */
	max-width: 100%;
	/* Garante que o dropdown-toggle ocupe toda a largura disponível */
}

.vs__dropdown-menu {
	width: fit-content(100em);
	max-width: 80vw;
	/* Limita a largura máxima ao tamanho da tela */
	max-height: fit-content;
}

// .modal-select .vs__dropdown-menu{
// 	height: clamp(9.6rem, 12dvh, 15rem) !important;
// 	max-height: clamp(9.6rem, 12dvh, 15rem) !important;
// }

.vs__dropdown-option {
	white-space: normal;
	/* Permite a quebra de linha */
	word-wrap: break-word;
	/* Quebra palavras longas */
	overflow-wrap: break-word;
	/* Quebra palavras longas */
}

.select-container .vs__selected-options {
	max-height: 8vh;
	overflow-y: auto;
	-ms-overflow-style: none;

	scrollbar-width: none; // Firefox

	// WebKit (Chrome, Safari, Edge Chromium, etc.)
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: transparent;
		border: none;
	}
}
</style>
